import { HexColor, ColorFunction, RelativeColorFunction, LightDark } from '@wix/thunderbolt-becky-root'
import { atomicStylePropsConverterMap } from '../../atomics/atomicPropsToCss'
import { mathConverterMap } from '../MathFunction/mathPropsToCss'
import _ from 'lodash'
import type { StylePropertiesTypes } from '@wix/document-services-types'

/** Internal Converters */
const hexColorConverter = (prop: HexColor): string => {
	return `${prop.value}`
}

const mapColorValues = (values: ColorFunction['values'] | RelativeColorFunction['values']) =>
	values.map((value) => colorFunctionConverterMap[value.type](value)).join(' ')

const colorFunctionConverter = (prop: ColorFunction): string => {
	const alpha = prop.alpha ? ` / ${atomicStylePropsConverterMap[prop.alpha.type](prop.alpha)}` : ''
	return `${prop.function}(${mapColorValues(prop.values)}${alpha})`
}

const relativeColorFunctionConverter = (prop: RelativeColorFunction): string => {
	const alpha = prop.alpha ? ` / ${atomicStylePropsConverterMap[prop.alpha.type](prop.alpha)}` : ''
	const fromColor = colorConverterMap[prop.from.type](prop.from)

	return `${prop.function}(from ${fromColor} ${mapColorValues(prop.values)}${alpha})`
}

const lightDarkConverter = (prop: LightDark): string => {
	const light = colorConverterMap[prop.light.type](prop.light)
	const dark = colorConverterMap[prop.dark.type](prop.dark)
	return `light-dark(${light}, ${dark})`
}

/** Internal Mappers */
const colorFunctionConverterMap = _.mergeWith({ ...mathConverterMap }, { ...atomicStylePropsConverterMap }) as Record<
	string,
	(
		prop:
			| StylePropertiesTypes.MathFunction
			| StylePropertiesTypes.Number
			| StylePropertiesTypes.Percentage
			| StylePropertiesTypes.Angle
			| StylePropertiesTypes.Keyword<string>
	) => string
>

/** External Mapper */
export const colorConverterMap = {
	HexColor: hexColorConverter,
	ColorFunction: colorFunctionConverter,
	RelativeColorFunction: relativeColorFunctionConverter,
	LightDark: lightDarkConverter,
	Keyword: atomicStylePropsConverterMap.Keyword, // KeywordColor support
} as Record<string, (prop: StylePropertiesTypes.Color) => string>
